import commonMessage from "../../constants/commonMessage";

const { SURVEY_CATEGORY_REQUIRED } = commonMessage;

export const surveyCategory = {
  // Add Category Schema
  addCategorySchema: {
    name: {
      required: true,
      message: SURVEY_CATEGORY_REQUIRED,
      extraMessage: false,
    },
    image: {
      required: true,
      message: "Category icon is required!",
      extraMessage: false,
    },
    orderNumber: {
      required: true,
      message: "Order number is required!",
      extraMessage: false,
    },
  },
};
